import { render, staticRenderFns } from "./AdvanceReportAdjustedDetails.vue?vue&type=template&id=720dd022"
import script from "./AdvanceReportAdjustedDetails.vue?vue&type=script&lang=js"
export * from "./AdvanceReportAdjustedDetails.vue?vue&type=script&lang=js"
import style0 from "./AdvanceReportAdjustedDetails.vue?vue&type=style&index=0&id=720dd022&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports